<template>
    <v-card class="rounded-0">
        <v-toolbar class="no-printable" color="primary" dark>
            
            <v-btn @click="cancelPrint" icon>
                <v-icon>mdi-close</v-icon>
            </v-btn>
            <v-toolbar-title>Impression {{docType}} N°{{avisToPrint.num_avis}}</v-toolbar-title>
            <v-select
            width="100px"
            class="ml-5"
            :items="['Prime', 'Unibox']"
            v-model="societe"
            hide-details
            dense
            ></v-select>
            <v-spacer></v-spacer>
            <!--Type de document à imprimer
            <v-select
            width="100px"
            class="ml-5"
            :items="['Avis', 'Pré-Avis']"
            v-model="docType"
            hide-details
            dense
            ></v-select>-->
            <v-spacer></v-spacer>
            <v-btn @click="print" text>
                Confirmer
                <v-icon>mdi-check</v-icon>
            </v-btn>

        </v-toolbar>
        <div class="fullwidth" v-if="societe === 'Prime'">
            <div class="width-50">
                <div class="printable-content">
                    <img class="logo" src="https://i.imgur.com/J8CnA93.png" />
                </div>
            </div>
            <div class="width-50">
                <div class="printable-content">
                    <div class="info-text">
                        <b>Prime Shipping Agency </b><br/>
                        3 Rue Habib Thameur 1er Etage App N°2 Rades 2040 <br/>
                        Ben Arous Tunisie. Tél. : +216 71 461 710 <br/>
                        Email : manager@primeshipping.tn <br/>
                    </div>
                </div>
            </div>
        </div>
        <div class="fullwidth" v-if="societe === 'Unibox'">
            <div class="width-50">
                <div class="printable-content">
                    <img class="logo" src="https://i.imgur.com/LBw0phu.jpg" />
                </div>
            </div>
            <div class="width-50">
                <div class="printable-content">
                    <div class="info-text">
                        <b>Unibox Express Delivery</b><br/>
                        Rue de l'exportation Zone Industrielle rades 2040 <br/>
                        Ben Arous Tunisie. Tél. : +216 71 461 699  <br/>
                        Email : safa.masri@unibox.tn <br/>
                    </div>
                </div>
            </div>
        </div>
        <div class="clearfix"></div>
        <div class="fullwidth">
            <div class="printable-content  p-b-0">
                <h3>{{docType}}</h3>
                <!--<h3 v-if="avisToPrint.dossier.type == 'Export'">{{docType}} d'embarquement N°{{avisToPrint.num_avis}}</h3>-->
            </div>
        </div>
        <div class="clearfix"></div>
        <div class="fullwidth">
            <div class="width-50">
                <div class="printable-content">
                    <div class="width-50">
                        <span class="client-label">Réf.Client : {{avisToPrint.client.code_client}} </span>
                    </div>
                    <div class="width-50">
                        <span class="client-label">Dossier N° : {{avisToPrint.dossier.num_dossier}} </span>
                    </div>
                </div>
            </div>
            <div class="width-50 right">
                <div class="printable-content right">
                    <span class="client-label right">Edité le : {{new Date() | formatDate()}} </span>
                </div>
            </div>
            <div class="clearfix"></div>
            
            <div class="width-50">
                <div class="fullwidth">
                    <div class="printable-content">
                        <div class="coordonnee-client">
                            <p class="text-line"><b>{{avisToPrint.client.fullname}}</b></p>
                            <p class="text-line">{{avisToPrint.client.adresse}}</p>
                            <p class="text-line">{{avisToPrint.client.region}} - {{avisToPrint.client.code_postal}}</p>
                            <p class="text-line">Tel : {{avisToPrint.client.tel}} - Fax : {{avisToPrint.client.fax}}</p>
                        </div>
                    </div>
                </div>
            </div>

            <div class="width-50">
                <div class="fullwidth">
                    <div class="printable-content">
                        
                    </div>
                </div>
            </div>
            <div class="clearfix"></div>
            <div class="fullwidth">
                <div class="printable-content p-t-0">
                    <div class="data-dossier">
                        <div class="single-data width-50" v-if="avisToPrint.dossier.classe !== 'Aérien'"><b>Navire:</b> {{avisToPrint.dossier.navire}}</div>
                        <div class="single-data width-50" v-if="avisToPrint.dossier.classe !== 'Aérien'"><b>B/L N°:</b> {{avisToPrint.bl}}</div>
                        <div class="single-data width-25" v-if="avisToPrint.dossier.classe === 'Aérien'"><b>Compagnie Aérienne:</b> {{avisToPrint.dossier.compagnie_aerienne}}</div>
                        <div class="single-data width-25" v-if="avisToPrint.dossier.classe === 'Aérien'"><b>N° LTA:</b> {{avisToPrint.dossier.num_lta}}</div>
                        <div class="single-data width-25" v-if="avisToPrint.dossier.classe === 'Aérien'"><b>N° Vol:</b> {{avisToPrint.dossier.num_vol}}</div>
                        <!--<div class="single-data"><b>Type Dossier</b> {{avisToPrint.dossier.type}}</div>-->
                        <div class="clearfix"></div>
                        <div class="single-data width-50" v-if="avisToPrint.dossier.classe !== 'Aérien'"><b>Embarqué de:</b> {{avisToPrint.dossier.port_from_name}}</div>
                        <div class="single-data width-50" v-else><b>Départ de:</b> {{avisToPrint.dossier.aeroport_depart}}</div>
                        <div class="single-data width-50"><b>Le:</b> {{avisToPrint.dossier.from_date | formatDate}}</div>
                        <div class="single-data width-50" v-if="avisToPrint.dossier.classe !== 'Aérien'"><b>Débarqué à:</b> {{avisToPrint.dossier.port_to_name}}</div>
                        <div class="single-data width-50" v-else><b>Arrivée à:</b> {{avisToPrint.dossier.aeroport_arrivee}}</div>
                        <div class="single-data width-50"><b>Le:</b> {{avisToPrint.dossier.to_date | formatDate}}</div>
                        <div class="single-data width-25" v-if="avisToPrint.dossier.classe !== 'Aérien'"><b>Voyage:</b> {{avisToPrint.dossier.voyage}}</div>
                        <div class="single-data width-25" v-if="avisToPrint.dossier.classe !== 'Aérien'"><b>Fournisseur:</b> {{avisToPrint.fournisseur}}</div>
                        <div class="single-data width-25" v-if="avisToPrint.dossier.classe !== 'Aérien'"><b>Terme:</b> {{avisToPrint.terme}}</div>
                        <div class="single-data width-25" v-if="avisToPrint.dossier.classe !== 'Aérien'"><b>P/C:</b> {{avisToPrint.pc}}</div>
                        <div class="single-data width-25" v-if="avisToPrint.dossier.classe !== 'Aérien'"><b>Escale:</b> {{avisToPrint.dossier.escale}}</div>
                        <!--<div class="single-data"><b>Armateur:</b> {{avisToPrint.dossier.armateur}}</div>-->
                        <div class="single-data" v-if="avisToPrint.dossier.classe !== 'Aérien'"><b>Consignataire:</b> {{avisToPrint.dossier.consig}}</div>
                        <!--<div class="single-data" v-if="avisToPrint.correspondant"><b>Correspondant:</b> {{avisToPrint.correspondant.nom}}</div>-->
                        <!--<div class="single-data" v-if="avisToPrint.agent"><b>Agent</b> {{avisToPrint.agent.nom}}</div>-->
                        <div class="single-data width-25" v-if="avisToPrint.dossier.classe === 'Groupage'"><b>N°Conteneur:</b> {{avisToPrint.dossier.conteneur_num}}</div>
                        <div class="single-data width-25" v-if="avisToPrint.dossier.classe === 'Groupage'"><b>Type Conteneur:</b> {{avisToPrint.dossier.conteneur_type}}</div>
                        <div class="single-data width-25" v-if="avisToPrint.dossier.classe === 'Groupage'"><b>N°Escale Magasin:</b> {{avisToPrint.dossier.num_escale_magasin}}</div>
                        <div class="single-data width-25" v-if="avisToPrint.dossier.classe === 'Groupage'"><b>Date Dépotage:</b> {{avisToPrint.dossier.date_depotage | formatDate}}</div>
                        <div class="single-data width-25" v-if="avisToPrint.dossier.classe === 'Groupage'"><b>Valeur:</b> {{avisToPrint.valeur}}</div>
                        <div class="single-data width-25" v-if="avisToPrint.dossier.classe === 'Groupage'"><b>Bureau:</b> {{avisToPrint.bureau}}</div>
                        <div class="single-data width-25" v-if="avisToPrint.dossier.classe === 'Groupage'"><b>Code Magasin:</b> {{avisToPrint.code_magasin}}</div>
                        <div class="clearfix"></div>
                    </div>
                </div>
            </div>
            <div class="clearfix"></div>
            <div class="fullwidth">
                <div class="printable-content">
                    <table border=0 class="table-print" width="100%">
                        <tr>
                            <td>Rub</td>
                            <td v-if="avisToPrint.dossier.classe !== 'Groupage' && avisToPrint.dossier.classe !== 'Aérien' ">Cont.Numéro</td>
                            <td v-if="avisToPrint.dossier.classe !== 'Groupage' && avisToPrint.dossier.classe !== 'Aérien' ">Cont.Type</td>
                            <td>Colis</td>
                            <td>Désignation Marchandises</td>
                            <td>Poids</td>
                            <td v-if="avisToPrint.dossier.classe === 'Groupage'">Volume</td>
                        </tr>
                        <tr v-for="marchandise in avisToPrint.marchandises" v-bind:key="marchandise.id">
                            <td>{{marchandise.rub}}</td>
                            <td v-if="avisToPrint.dossier.classe !== 'Groupage' && avisToPrint.dossier.classe !== 'Aérien' ">{{marchandise.cont_numero}}</td>
                            <td v-if="avisToPrint.dossier.classe !== 'Groupage' && avisToPrint.dossier.classe !== 'Aérien' ">{{marchandise.cont_type}}</td>
                            <td>{{marchandise.colis}}</td>
                            <td>{{marchandise.description}}</td>
                            <td>{{marchandise.poids.toLocaleString()}}</td>
                            <td v-if="avisToPrint.dossier.classe === 'Groupage'">{{marchandise.volume}}</td>
                        </tr>
                    </table>
                </div>
            </div>
            
        </div>
    </v-card>
</template>
<script>
    var writtenNumber = require('written-number');
    import Printd from 'printd'
    export default {
        name: 'print-bad',
        data: () => ({
            d: null,
            docType: 'Bon à Délivrer',
            cssText: `
            @import url('https://fonts.googleapis.com/css2?family=Montserrat&display=swap');
            .right {
                text-align:right;
            }
            .total p{
                font-size:10px;
                padding: 2px;
            }
            .p-b-0{
                padding-bottom:0px !important;
            }
            .p-t-0{
                padding-top: 0px !important;
            }
            .total{
                padding: 10px;
                border: 1px solid rgba(0,0,0,0.2);
                margin-left: 20px;
                margin-bottom:10px;
            }
            *{
                margin:0;
                font-family: "Montserrat",sans-serif;
                outline: none;
            }
            .right {
                text-align:right;
            }
            .no-printable {
                display:none;
            }
            .fullwidth{
                width:100%;
            }
            .width-50{
                width:50% !important;
                float:left;
            }
            .width-75{
                width:75% !important;
                float:left;
            }
            .width-25{
                width:25% !important;
                float:left;
            }
            .printable-content{
                margin: 8px;
                padding:15px;
            }
            .logo {
                width:150px;
            }
            .info-text {
                font-size:14px !important;
                line-height:20px;
                font-weight:400 !important;
                letter-spacing:1.2px;
                color: #000;
            }
            .clearfix{
                clear:both;
            }
            .client-label{
                font-size:14px;
            }
            .coordonnee-client{
                border: 0px solid rgba(0,0,0,0.2);
                padding:15px;
            }
            .coordonnee-bancaire{
                border: 2px solid rgba(0,0,0,0.2);
                padding:15px;
            }
            .text-line{
                font-size:14px;
                font-weight:normal;
            }
            .table-print{
                border-collapse: collapse;
            }
            .table-print td{
                padding:2px 4px;
                font-size:11px;
            }
            .table-print td{
                border: 1px solid rgba(0,0,0,0.2);
            }
            .footer-data{
                font-size:10px;
                line-height:18px;
                letter-spacing:1.2px;
            }
            .data-dossier .single-data{
                //width:25%;
                float:left;
                font-size:11px;
                margin-top:3px;
                height: 15px;
            }
            .info-bar{
                font-size: 12px;
            }
            .no-border{
                border: 0px solid !important;
            }
            `,
            avisToPrint: {
                client: {},
                dossier: {},
                correspondant: {},
                agent: {}
            },
            totalnt: 0,
            totalt: 0,
            totaltva: 0,
            total: 0,
            societe: 'Prime',
            assiette: [],
            totaltext: '',
            documentDataValues: [],
            documentDataKeys: [],
            num: writtenNumber(1234, {lang: 'fr'})
            }),
        props: ['currentAvis'],
        mounted() {
            this.axios
            .get("/avis/single/"+this.currentAvis)
            .then(response => {
                this.avisToPrint = response.data
                this.totalnt = 0
                this.totalt = 0
                this.totaltva = 0
                this.total = 0
                response.data.prestations.forEach((item , index) => {
                    item.cour = Number(item.cour)
                    item.montant = Number(item.montant)
                    item.montantDevise = Number(item.montantDevise)
                    item.tva = Number(item.tva)
                    if(item.cour > 0){
                        response.data.prestations[index].montant = item.cour * item.montantDevise
                    } 
                    if(item.tva === 0){
                        this.totalnt = item.montant + this.totalnt
                    }else{
                        this.totaltva = item.montant * item.tva / 100  + this.totaltva
                        this.totalt = item.montant + this.totalt
                    }
                    item.montantTva = Number(item.montant.toFixed(3)) * item.tva / 100
                    let cass = this.assiette.find(o => o.taux === item.tva)
                    if(cass){
                        var index = this.assiette.indexOf(cass)
                        this.assiette[index].assiette = Number(this.assiette[index].assiette) + Number(item.montant.toFixed(3))
                        this.assiette[index].tva = Number(this.assiette[index].tva) + item.montantTva
                    }else{
                        this.assiette.push({taux: item.tva, assiette: item.montant, tva: item.montantTva})
                    }
                })
                this.total =  Number(this.total.toFixed(3)) + Number(this.totalnt.toFixed(3)) + Number(this.totalt.toFixed(3)) + Number(this.totaltva.toFixed(3)) + 0.6
                
                let tot = (this.total).toFixed(3)

                var vergulepos = tot.toString().indexOf('.')
                var bef_total = tot.toString().slice(0, vergulepos)
                var af_total = tot.toString().slice(vergulepos+1, tot.length)

                this.totaltext = writtenNumber(bef_total, {lang: 'fr'}) + ' dinars'
                if(Number(af_total) > 0){
                    this.totaltext = this.totaltext + " et " + writtenNumber(af_total, {lang: 'fr'}) + ' millimes'
                }
                
            })
            

            
        },
        methods: {
            print(){
                this.d = new Printd()
                this.d.print( this.$el, [this.cssText])
                this.$emit('closePrintDialog', true)
            },
            cancelPrint(){
                this.$emit('hide', true)
            },
            calculate(){
                
            },
        }
    }
</script>
<style scoped>
.right {
    text-align:right;
}
div {
    text-align:left;
}
.logo {
    width:150px;
}
.printable-content{
    margin: 8px;
    padding:15px;
}
.fullwidth{
    width:100%;
}
.right {
    text-align:right;
}
.fullwidth{
    width:100%;
}
.width-50{
    width:50% !important;
    float:left;
}
.width-75{
    width:75% !important;
    float:left;
}
.width-25{
    width:25% !important;
    float:left;
}
.info-text {
    font-size:14px !important;
    line-height:20px;
    font-weight:400 !important;
    letter-spacing:1.2px;
    color: #000;
}
.clearfix{
    clear:both;
}
.p-b-0{
    padding-bottom:0px !important;
}
.client-label{
    font-size:12px;
}
.coordonnee-client{
    border: 2px solid rgba(0,0,0,0.2);
    padding:15px;
    margin: 5px;
}
.coordonnee-bancaire{
    border: 2px solid rgba(0,0,0,0.2);
    padding:15px;
}
.text-line{
    font-size:14px;
    font-weight:normal;
}
.table-print{
    border-collapse: collapse;
}
.table-print td{
    padding:5px 7px;
}
.table-print td{
    border: 1px solid rgba(0,0,0,0.2);
}
.footer-data{
    font-size:13px;
    line-height:20px;
    letter-spacing:1.5px;
}
.data-dossier .single-data{
    width:25%;
    float:left;
}
.no-border{
    border: 0px solid !important;
}
</style>


// WEBPACK FOOTER //
// src/views/dashboard/dossier/bad/print.component.vue